<template>
  <div class="header-filter-controls" id="header__controls__project_calendar">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 left-side">
          <div class="form-inline" v-if="$router.currentRoute.name == 'globalAlert'">
            <b-button class="header-filter-btns" variant="theme" @click="$emit('createNewAlert')">
              Add Alert
              <i class="fas text-primary fa-plus fa-fw"></i>
            </b-button>
          </div>
          <div class="form-inline"
            v-if="$router.currentRoute.name != 'permissionManager' && $router.currentRoute.name != 'globalAlert' && $router.currentRoute.name != 'userGlobalAlert'">
            <div class="input-group top-search">
              <input type="text" class="form-control"
                :class="$router.currentRoute.name == 'globalSearch' ? '' : 'media-calls-search'" v-model="searchQuery"
                v-debounce:500ms="setQuery" :debounce-events="['keyup']"
                :placeholder="$router.currentRoute.name == 'globalSearch' ? 'Global search...' : 'Search ' + deliverableTypePlaceholder + '...'"
                @click="$refs.searchQuery.select()" @keypress.enter="triggerSearch" ref="searchQuery"
                id="search-query" />
              <div class="input-group-append cursor-pointer" @click="triggerSearch">
                <span class="input-group-text">
                  <i class="fas fa-search"></i>
                </span>
              </div>
            </div>
            <b-button ref="filterBoxBtn" id="popover-button-event-calendar" class="ml-2 header-filter-btns"
              variant="theme" tabindex="0" href="#" v-if="$router.currentRoute.name != 'globalSearch'"
              @keydown.esc="$refs.popover.$emit('close')">
              <span class="wider-filter-only">Filter</span>
              <img src="@/csmworkflow/img/filter.svg" />
            </b-button>
            <b-popover triggers="click blur" boundary="window" placement="bottom" ref="popover"
              target="popover-button-event-calendar" custom-class="deliverable-filter">
              <div class="d-flex flex-row">
                <div class="filter-item item__status">
                  <label>Task Status</label>
                  <div v-if="!isMobile()" class="status-wrap">
                    <a href="#" @click="setStatusFilter(s)" class="badge mr-2"
                      :style="{ color: 'var(--wf-secondary)', backgroundColor: s.color }" v-for="(s, index) in statuses"
                      :key="index">{{ s.name }}</a>
                  </div>
                  <div class="custom-field status-field">
                    <multiselect v-if="isMobile()" :searchable="true" v-model="filterQuery.status" label="name"
                      :options="statuses" placeholder="Select status" :show-labels="false" :multiple="true"
                      :hide-selected="true">
                      <template slot="option" slot-scope="props">
                        <div
                          :style="{ color: 'var(--wf-secondary)', borderRadius: '10px', backgroundColor: props.option.color, height: '40px', lineHeight: '40px', textAlign: 'center' }">
                          {{ props.option.name }}</div>
                      </template>
                      <template slot="tag" slot-scope="props">
                        <div
                          :style="{ color: 'var(--wf-secondary)', borderRadius: '10px', backgroundColor: props.option.color, textAlign: 'center', display: 'inline-block', padding: '5px 10px', marginRight: '5px' }">
                          {{ props.option.name }}</div>
                      </template>
                    </multiselect>
                  </div>
                </div>
                <div class="grouped-filter-item">
                  <div class="filter-item item__outlet">
                    <div>
                      <label>Outlet</label>
                      <b-form-checkbox v-if="isMobile()" class="float-right csm-checkbox" v-model="filterQuery.noOutlet"
                        id="no-outlet" name="no-outlet" value="accepted" unchecked-value="not_accepted"
                        @input="filterQuery.noOutlet == 'accepted' ? filterQuery.outlet = [] : ''">No
                        Outlet</b-form-checkbox>
                    </div>
                    <div class="outlet-wrap">
                      <multiselect ref="outletFilter" v-model="filterQuery.outlet" track-by="id" open-direction="bottom"
                        label="name" :options="contacts" :show-labels="false" :multiple="true" :close-on-select="false"
                        :hide-selected="true" :preserve-search="true" :clear-on-select="false" :internal-search="false"
                        :loading="isContactsLoading" @select="filterQuery.noOutlet = 'not_accepted'"
                        @search-change="onWhoSearch">
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options
                            selected</span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <span class="option__title">{{ props.option.name }}</span>
                            <br />
                            <span class="option__small text-muted">{{ props.option.company_name }}</span>
                          </div>
                        </template>
                        <template slot="noOptions">Start typing to find contacts.</template>

                        <template slot="noResult">No results. Please try changing the search query.</template>
                      </multiselect>
                    </div>
                    <b-form-checkbox v-if="!isMobile()" class="mt-2 csm-checkbox" v-model="filterQuery.noOutlet"
                      id="no-outlet" name="no-outlet" value="accepted" unchecked-value="not_accepted"
                      @input="filterQuery.noOutlet == 'accepted' ? filterQuery.outlet = [] : ''">No
                      Outlet</b-form-checkbox>
                  </div>
                  <div class="filter-item item__coordinator">
                    <label>Coordinator</label>
                    <div class="coordinator-wrap">
                      <multiselect ref="coordinatorFilter" v-model="filterQuery.coordinator" :options="allActiveUsers"
                        :show-labels="false" :multiple="true" open-direction="bottom" label="name" track-by="id"
                        :hideSelected="false" :hide-selected="false" :close-on-select="false" :clear-on-select="false">
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options
                            selected</span>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                  <div class="filter-item item__deliverable__type" v-if="$router.currentRoute.name != 'globalSearch'">
                    <label>Deliverable Type</label>
                    <div class="deliverable-type-wrap">
                      <multiselect ref="deliverableTypeFilter" v-model="filterQuery.deliverableType"
                        :options="newDeliverableTypes" :show-labels="false" :multiple="true" open-direction="bottom"
                        label="name" track-by="id" :hideSelected="false" :hide-selected="false" :close-on-select="false"
                        :clear-on-select="false">
                      </multiselect>
                    </div>
                  </div>
                </div>
                <div class="grouped-filter-item">
                  <div class="filter-item item__department">
                    <div>
                      <label>Department</label>
                      <b-form-checkbox v-if="isMobile()" class="float-right csm-checkbox"
                        v-model="filterQuery.noDepartment" id="no-department" name="no-department" value="accepted"
                        unchecked-value="not_accepted"
                        @input="filterQuery.noDepartment == 'accepted' ? filterQuery.department = [] : ''">No
                        Department</b-form-checkbox>
                    </div>
                    <div class="tag-wrap">
                      <multiselect ref="departmentFilter" v-model="filterQuery.department" open-direction="bottom"
                        label="name" track-by="id" :options="departments" :hideSelected="false" :hide-selected="false"
                        :show-labels="false" :multiple="true" :close-on-select="false" :clear-on-select="false"
                        @select="filterQuery.noDepartment = 'not_accepted'">
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options
                            selected</span>
                        </template>
                        <template slot="noOptions">Start typing to find departments.</template>

                        <template slot="noResult">No results. Please try changing the search query.</template>
                      </multiselect>
                    </div>
                    <b-form-checkbox v-if="!isMobile()" class="mt-2 csm-checkbox" v-model="filterQuery.noDepartment"
                      id="no-department" name="no-department" value="accepted" unchecked-value="not_accepted"
                      @input="filterQuery.noDepartment == 'accepted' ? filterQuery.department = [] : ''">No
                      Department</b-form-checkbox>
                  </div>
                  <div class="filter-item item__tag">
                    <label>Tag</label>
                    <div class="tag-wrap">
                      <multiselect ref="tagFilter" v-model="filterQuery.tag" :options="tags" :show-labels="false"
                        :multiple="true" open-direction="bottom" label="name" track-by="id" :hideSelected="false"
                        :hide-selected="false" :close-on-select="false" :clear-on-select="false"
                        :loading="isTagsLoading" :preserve-search="true" @search-change="onTagSearch">
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options
                            selected</span>
                        </template>
                        <template slot="noOptions">Start typing to find tags.</template>

                        <template slot="noResult">No results. Please try changing the search query.</template>
                      </multiselect>
                    </div>
                  </div>
                </div>
                <div class="filter-item item__date">
                  <div class="due__created__dates">
                    <div>
                      <label>Due Date</label>
                      <br />
                      <date-range-picker ref="picker" @update="onUpdateDueDate" :autoApply="true"
                        :ranges="customDueDateRanges" v-model="filterQuery.dateRange"></date-range-picker>
                    </div>
                    <div>
                      <label class="mt-2">Created</label>
                      <br />
                      <date-range-picker ref="pickerDateCreated" @update="onUpdateDateCreated" :autoApply="true"
                        :ranges="customCreatedDateRanges" v-model="filterQuery.dateCreatedRange"></date-range-picker>
                    </div>
                  </div>

                  <div>
                    <label class="mt-lg-2">Completed</label>
                    <br />
                    <date-range-picker ref="pickerDateCompleted" @update="onUpdateDateCompleted" :autoApply="true"
                      :ranges="customCompletedDateRanges" v-model="filterQuery.dateCompletedRange"></date-range-picker>
                  </div>
                </div>
                <div class="filter-item item__priority filter-item-no-border">
                  <div class="priority__filter">
                    <label>Priority</label>
                    <br />
                    <div @click="setPriority" class="filter-rating">
                      <vue-star-rate :rateRange="filterQuery.priorityFilter" :maxIcon="5" :iconHeight="17"
                        :iconWidth="17" :hasCounter="false" iconColor="var(--wf-primary)"
                        iconColorHover="var(--wf-primary)" iconShape="circle"></vue-star-rate>
                    </div>
                  </div>

                  <div class="priority__sort">
                    <label class="mt-2">Sort by Priority</label>
                    <br>
                    <div v-if="$router.currentRoute.name != 'globalSearch'"
                      class="btn-group add-new__global_search sorting main__filter">
                      <button class="btn btn-theme header-filter-btns dropdown-toggle" type="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Sort
                        <i class="fas fa-sort text-primary float-right"></i>
                      </button>
                      <div class="dropdown-menu">
                        <a class="dropdown-item" @click="setSort('priorityDesc')" href="#">Priority Descending</a>
                        <a class="dropdown-item" @click="setSort('priorityAsc')" href="#">Priority Ascending</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="item__reset">
                    <b-button variant="theme" title="Reset All Filter" size="sm" @click="resetFilter"><i
                        class="fas fa-undo"></i></b-button>
                    <b-button class="d-block d-lg-none" variant="theme" title="Close Filter Popup" size="sm"
                      @click="$refs.popover.$emit('close')"><i class="fas fa-times"></i></b-button>
                  </div>
                </div>
              </div>
              <div class="d-none d-md-block mt-3 test1"
                v-if="filterQuery.noDepartment == 'accepted' || filterQuery.noOutlet == 'accepted' || filterQuery.filterNoDueDate || filterQuery.query || filterQuery.status.length || filterQuery.filterByDate || filterQuery.filterByDateCreated || filterQuery.filterByDateCompleted || filterQuery.coordinator.length || filterQuery.outlet.length || ((Array.isArray(filterQuery.deliverableType) && filterQuery.deliverableType.length) || (!Array.isArray(filterQuery.deliverableType) && filterQuery.deliverableType)) || filterQuery.tag.length || filterQuery.department.length || filterQuery.sort || filterQuery.priorityFilter > 0">
                <label>Click to remove filters:</label>
                <br />
                <span class="badge badge-primary mr-2 mb-2" @click="filterQuery.query = null; searchQuery = ''"
                  :style="{ cursor: 'pointer' }">{{ filterQuery.query }}</span>
                <span class="badge mr-2 mb-2" @click="removeFilter(status)"
                  :style="{ cursor: 'pointer', color: 'var(--wf-secondary)', backgroundColor: status.color }"
                  v-for="status in filterQuery.status">{{ status.name }}</span>
                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(outlet)" :style="{ cursor: 'pointer' }"
                  v-for="outlet in filterQuery.outlet">{{ outlet.name }}</span>
                <span v-if="Array.isArray(filterQuery.deliverableType)">
                  <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(deliverableType)"
                    :style="{ cursor: 'pointer' }" v-for="deliverableType in filterQuery.deliverableType">{{
                      deliverableType.name }}</span>
                </span>
                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('deliverableType')"
                  :style="{ cursor: 'pointer' }" v-else>{{ filterQuery.deliverableType.name }}</span>
                <span v-if="filterQuery.priorityFilter > 0" class="badge badge-primary mr-2 mb-2"
                  @click="removeFilter('resetPriorityFilter')" :style="{ cursor: 'pointer' }">Priority {{
                    filterQuery.priorityFilter
                  }}</span>
                <span v-if="$router.currentRoute.name != 'globalSearch' && filterQuery.sort"
                  class="badge mr-2 mb-2 bg-primary cursor-pointer" style="color: var(--wf-secondary);"
                  @click="removeFilter('resetDeliverableSort')">
                  {{ filterQuery.sort == 'priorityDesc' ? 'Priority Descending' : 'Priority Ascending' }}</span>
                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(coordinator)"
                  :style="{ cursor: 'pointer' }" v-for="coordinator in filterQuery.coordinator">{{ coordinator.name
                  }}</span>
                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('filterByDate')"
                  :style="{ cursor: 'pointer' }" v-if="filterQuery.filterByDate">Due Date: {{
                    filterQuery.dateRange.startDate | moment('MMM DD') }} - {{
                    filterQuery.dateRange.endDate | moment('MMM DD') }}</span>
                <span class="badge badge-primary mr-2 mb-2" @click="filterQuery.filterNoDueDate = false"
                  :style="{ cursor: 'pointer' }" v-if="filterQuery.filterNoDueDate == 1">No Due Date</span>
                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('filterByDateCreated')"
                  :style="{ cursor: 'pointer' }" v-if="filterQuery.filterByDateCreated">Created: {{
                    filterQuery.dateCreatedRange.startDate | moment('MMM DD') }} - {{
                    filterQuery.dateCreatedRange.endDate | moment('MMM DD') }}</span>
                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('filterByDateCompleted')"
                  :style="{ cursor: 'pointer' }" v-if="filterQuery.filterByDateCompleted">Completed: {{
                    filterQuery.dateCompletedRange.startDate | moment('MMM DD') }} - {{
                    filterQuery.dateCompletedRange.endDate |
                    moment('MMM DD') }}</span>

                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(tag)" :style="{ cursor: 'pointer' }"
                  v-for="tag in filterQuery.tag">{{ tag.name }}</span>
                <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(department)"
                  :style="{ cursor: 'pointer' }" v-for="department in filterQuery.department">{{ department.name
                  }}</span>
                <span class="badge badge-primary mr-2 mb-2" @click="filterQuery.noDepartment = 'not_accepted'"
                  :style="{ cursor: 'pointer' }" v-if="filterQuery.noDepartment == 'accepted'">No Department</span>
                <span class="badge badge-primary mr-2 mb-2" @click="filterQuery.noOutlet = 'not_accepted'"
                  :style="{ cursor: 'pointer' }" v-if="filterQuery.noOutlet == 'accepted'">No Outlet</span>
              </div>
            </b-popover>

            <div class="new-deliverables ml-2">
              <div class="btn-group wider-filter-only">
                <button type="button" class="btn-theme btn-split-button header-filter-btns"
                  @click="createNewDeliverable()">New
                  {{ deliverableType ? deliverableType.name : "Deliverable" }} <i
                    class="fas text-primary float-right fa-plus fa-fw"></i></button>
                <button type="button" class="btn-theme dropdown-toggle dropdown-toggle-split btn-split-button"
                  data-toggle="dropdown" aria-expanded="false" v-if="hasMultipleDeliverableType">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <a class="dropdown-item" href="#" v-for="(type, i) in newDeliverableTypes" :key="i"
                    @click="createDeliverableDropdownClick(type)">{{ type.name }}</a>
                </div>
              </div>
              <div class="mobile-filter-only">
                <button type="button" v-if="hasMultipleDeliverableType" class="btn btn-theme header-filter-btns"
                  data-toggle="dropdown" aria-expanded="false">New <i class="fas text-primary float-right fa-plus fa-fw"
                    style="margin-left: 10px"></i></button>
                <button type="button" v-else class="btn btn-theme header-filter-btns"
                  @click="createNewDeliverable()">New <i class="fas text-primary float-right fa-plus fa-fw"
                    style="margin-left: 10px"></i></button>
                <div v-if="hasMultipleDeliverableType" class="dropdown-menu">
                  <a class="dropdown-item" href="#" v-for="(type, i) in newDeliverableTypes" :key="i"
                    @click="createDeliverableDropdownClick(type)">{{ type.name }}</a>
                </div>
              </div>
            </div>

            <div v-if="$router.currentRoute.name == 'globalSearch'" class="btn-group add-new__global_search">
              <b-button @keydown.esc="$refs.GSCreatedDatePopover.$emit('close')" class="ml-md-2 header-filter-btns"
                variant="theme" @click="GSCreatedDatePopover = !GSCreatedDatePopover" ref="GSCreatedDate"
                id="GSCreatedDate">
                Created Date
                <i class="far fa-calendar-check text-primary"></i>
              </b-button>
              <b-popover ref="GSCreatedDatePopover" :show.sync="GSCreatedDatePopover" target="GSCreatedDate"
                triggers="click blur" placement="bottom" custom-class="filter_popover__gs created-date-popover">
                <date-range-picker ref="pickerDateCreated" opens="inline" @update="onUpdateDateCreated"
                  :autoApply="true" :ranges="customCreatedDateRanges"
                  v-model="filterQuery.dateCreatedRange"></date-range-picker>
              </b-popover>
            </div>
            <div
              v-if="$router.currentRoute.name == 'globalSearch' && (GSDataType == 'departments' || GSDataType == 'tags' || GSDataType == 'contacts' || GSDataType == 'coordinators')"
              class="btn-group add-new__global_search">
              <div class="ml-md-2 toggle-dept-status cursor-pointer"
                @click="filterQuery.status[0] == 'Active' ? filterQuery.status = ['Archived'] : filterQuery.status = ['Active']">
                <b-button class="header-filter-btns" :class="{ 'none-active-btn': filterQuery.status[0] != 'Active' }"
                  variant="theme">
                  Active
                  <i class="fas fa-toggle-on text-primary float-right ml-2"></i>
                </b-button>
                <b-button class="header-filter-btns" :class="{ 'none-active-btn': filterQuery.status[0] != 'Archived' }"
                  variant="theme">
                  Archived
                  <i class="fas fa-toggle-off text-primary float-right ml-2"></i>
                </b-button>
              </div>
            </div>
            <div
              v-if="$router.currentRoute.name == 'globalSearch' && (GSDataType == 'departments' || GSDataType == 'tags')"
              class="btn-group add-new__global_search sorting">
              <button class="btn btn-theme ml-md-2 header-filter-btns dropdown-toggle" type="button"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Sort
                <i class="fas fa-sort text-primary float-right"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item" @click="setSort('usedDesc')" href="#">Frequency Descending</a>
                <a class="dropdown-item" @click="setSort('usedAsc')" href="#">Frequency Ascending</a>
              </div>
            </div>
            <div v-if="$router.currentRoute.name == 'globalSearch' && GSDataType == 'all'"
              class="btn-group add-new__global_search">
              <b-button class="ml-md-2 header-filter-btns dropdown-toggle" variant="theme" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">Add</b-button>
              <div class="dropdown-menu">
                <a v-if="userAbilities.createTag || userAbilities.editMediaCall" class="dropdown-item"
                  @click="$emit('click', 'tag')" href="#">Add Tags</a>
                <a v-if="userAbilities.createContact || userAbilities.editMediaCall" class="dropdown-item"
                  @click="$emit('click', 'contact')" href="#">Add Contacts</a>
                <a v-if="userAbilities.createUser" class="dropdown-item" @click="$emit('click', 'coordinator')"
                  href="#">Add
                  Coordinators</a>
                <a v-if="userAbilities.createDepartment || userAbilities.editMediaCall" class="dropdown-item"
                  @click="$emit('click', 'department')" href="#">Add Departments</a>
              </div>
            </div>
            <div v-if="$router.currentRoute.name == 'globalSearch' && GSDataType != 'all'"
              :class="!checkPermissions ? 'no-permission' : ''" class="btn-group add-new__global_search specific-btn">
              <b-button v-if="checkPermissions"
                @click.prevent="$emit('click', GSDataType.substring(0, GSDataType.length - 1))" variant="theme"
                class="ml-md-2 header-filter-btns action">
                Add
                <span style="text-transform: capitalize">{{ tabType }}</span>
              </b-button>
              <div class="btn-group">
                <button type="button" v-if="checkPermissions" class="btn btn-theme dropdown-toggle options"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <b-button class="ml-md-2 header-filter-btns dropdown-toggle" v-if="!checkPermissions" variant="theme"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Add</b-button>
                <div class="dropdown-menu">
                  <a v-if="GSDataType != 'tags' && (userAbilities.createTag || userAbilities.editMediaCall)"
                    class="dropdown-item" @click="$emit('click', 'tag')" href="#">Add Tags</a>
                  <a v-if="GSDataType != 'contacts' && (userAbilities.createContact || userAbilities.editMediaCall)"
                    class="dropdown-item" @click="$emit('click', 'contact')" href="#">Add Contacts</a>
                  <a v-if="GSDataType != 'coordinators' && userAbilities.createUser" class="dropdown-item"
                    @click="$emit('click', 'coordinator')" href="#">Add Coordinators</a>
                  <a v-if="GSDataType != 'departments' && (userAbilities.createDepartment || userAbilities.editMediaCall)"
                    class="dropdown-item" @click="$emit('click', 'department')" href="#">Add Departments</a>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-3 filter-badges"
            v-if="filterQuery.noDepartment == 'accepted' || filterQuery.noOutlet == 'accepted' || filterQuery.filterNoDueDate || filterQuery.query || filterQuery.status.length || filterQuery.filterByDate || filterQuery.filterByDateCreated || filterQuery.filterByDateCompleted || filterQuery.coordinator.length || filterQuery.outlet.length || ((Array.isArray(filterQuery.deliverableType) && filterQuery.deliverableType.length) || (!Array.isArray(filterQuery.deliverableType) && filterQuery.deliverableType)) || filterQuery.tag.length || filterQuery.department.length || filterQuery.sort || filterQuery.priorityFilter > 0">
            <label class="remove-filter-text">Click to remove filters:</label>
            <span class="badge badge-primary mr-2 mb-2" @click="filterQuery.query = null; searchQuery = ''"
              :style="{ cursor: 'pointer' }">{{ filterQuery.query }}</span>
            <span v-if="$router.currentRoute.name != 'globalSearch'" class="badge mr-2 mb-2"
              @click="removeFilter(status)"
              :style="{ cursor: 'pointer', color: 'var(--wf-secondary)', backgroundColor: status.color }"
              v-for="status in filterQuery.status">{{ status.name }}</span>
            <span v-if="$router.currentRoute.name == 'globalSearch'" class="badge mr-2 mb-2 bg-primary cursor-pointer"
              style="color: var(--wf-secondary);" @click="removeFilter('resetDepartStatus')">{{ filterQuery.status[0]
              }}</span>
            <span v-if="$router.currentRoute.name == 'globalSearch' && filterQuery.sort"
              class="badge mr-2 mb-2 bg-primary cursor-pointer" style="color: var(--wf-secondary);"
              @click="removeFilter('resetDepartTagSort')">
              {{ filterQuery.sort == 'usedDesc' ? 'Frequency Descending' : 'Frequency Ascending' }}</span>
            <span v-if="filterQuery.priorityFilter > 0" class="badge badge-primary mr-2 mb-2"
              @click="removeFilter('resetPriorityFilter')" :style="{ cursor: 'pointer' }">Priority {{
                filterQuery.priorityFilter
              }}</span>
            <span v-if="$router.currentRoute.name != 'globalSearch' && filterQuery.sort"
              class="badge mr-2 mb-2 bg-primary cursor-pointer" style="color: var(--wf-secondary);"
              @click="removeFilter('resetDeliverableSort')">
              {{ filterQuery.sort == 'priorityDesc' ? 'Priority Descending' : 'Priority Ascending' }}</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(outlet)" :style="{ cursor: 'pointer' }"
              v-for="outlet in filterQuery.outlet">{{ outlet.name }}</span>
            <span v-if="Array.isArray(filterQuery.deliverableType)">
              <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(deliverableType)"
                :style="{ cursor: 'pointer' }" v-for="deliverableType in filterQuery.deliverableType">{{
                  deliverableType.name }}</span>
            </span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('deliverableType')"
              :style="{ cursor: 'pointer' }" v-else>{{ filterQuery.deliverableType.name }}</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(coordinator)"
              :style="{ cursor: 'pointer' }" v-for="coordinator in filterQuery.coordinator">{{ coordinator.name
              }}</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('filterByDate')"
              :style="{ cursor: 'pointer' }" v-if="filterQuery.filterByDate">Due Date: {{
                filterQuery.dateRange.startDate
                | moment('MMM DD') }} - {{
                filterQuery.dateRange.endDate | moment('MMM DD') }}</span>
            <span class="badge badge-primary mr-2 mb-2" @click="filterQuery.filterNoDueDate = false"
              :style="{ cursor: 'pointer' }" v-if="filterQuery.filterNoDueDate == 1">No Due Date</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('filterByDateCreated')"
              :style="{ cursor: 'pointer' }" v-if="filterQuery.filterByDateCreated">Created: {{
                filterQuery.dateCreatedRange.startDate | moment('MMM DD') }} - {{
                filterQuery.dateCreatedRange.endDate | moment('MMM DD') }}</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter('filterByDateCompleted')"
              :style="{ cursor: 'pointer' }" v-if="filterQuery.filterByDateCompleted">Completed: {{
                filterQuery.dateCompletedRange.startDate | moment('MMM DD') }} - {{ filterQuery.dateCompletedRange.endDate
                |
                moment('MMM DD') }}</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(tag)" :style="{ cursor: 'pointer' }"
              v-for="tag in filterQuery.tag">{{ tag.name }}</span>
            <span class="badge badge-primary mr-2 mb-2" @click="removeFilter(department)" :style="{ cursor: 'pointer' }"
              v-for="department in filterQuery.department">{{ department.name }}</span>
            <span class="badge badge-primary mr-2 mb-2" @click="filterQuery.noDepartment = 'not_accepted'"
              :style="{ cursor: 'pointer' }" v-if="filterQuery.noDepartment == 'accepted'">No Department</span>
            <span class="badge badge-primary mr-2 mb-2" @click="filterQuery.noOutlet = 'not_accepted'"
              :style="{ cursor: 'pointer' }" v-if="filterQuery.noOutlet == 'accepted'">No Outlet</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Logo from "./Logo";
import LoggedInUser from "./LoggedInUser";
import HeaderNotification from "./HeaderNotification";
import FeedbackBtn from "./FeedbackBtn";
import FeedbackModal from "./FeedbackModal";
import ViewTitleModal from "./ViewTitleModal";
import vueStarRate from "vue-js-star-rating";

export default {
  props: {
    myWeek: Boolean,
    namespace: String,
    GSDataType: String,
    projectDeliverable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      deliverableType: [],
      GSCreatedDatePopover: false,
      customDueDateRanges: {
        "No Due Date": [null, null],
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
        "Next week": [
          this.$moment().startOf("week").add(7, "days").toDate(),
          this.$moment().endOf("week").add(7, "days").toDate(),
        ],
        "Next two weeks": [
          this.$moment().startOf("week").add(7, "days").toDate(),
          this.$moment().endOf("week").add(14, "days").toDate(),
        ],
      },
      customCreatedDateRanges: {
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
      },
      customCompletedDateRanges: {
        Yesterday: [
          this.$moment().subtract(1, "days").toDate(),
          this.$moment().subtract(1, "days").toDate(),
        ],
        "Last week": [
          this.$moment().subtract(7, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        "Last two week": [
          this.$moment().subtract(14, "days").startOf("week").toDate(),
          this.$moment().subtract(7, "days").endOf("week").toDate(),
        ],
        Today: [this.$moment().toDate(), this.$moment().toDate()],
        "This week": [
          this.$moment().startOf("week").toDate(),
          this.$moment().endOf("week").toDate(),
        ],
      },
      searchQuery: "",
      isContactsLoading: false,
      isTagsLoading: false,
      isDepartmentsLoading: false,
      contacts: [],
      tags: [],
      departments: [],
      showUserSelect: false,
      filterQuery: {
        sort: "",
        query: "",
        filterByDate: false,
        dateRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        dateCreatedRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        dateCompletedRange: {
          startDate: new Date(),
          endDate: new Date(),
        },
        status: [],
        outlet: [],
        deliverableType: [],
        tag: [],
        department: [],
        coordinator: [],
        noDepartment: "not_accepted",
        noOutlet: "not_accepted",
        initialized: false,
      },
    };
  },
  components: {
    Logo,
    vueStarRate,
    HeaderNotification,
    LoggedInUser,
    FeedbackBtn,
    FeedbackModal,
    ViewTitleModal,
  },
  computed: {
    ...mapGetters([
      "getSystemSetting",
      "deliverableTypes",
      "allDeliverableTypes",
      "newDeliverableTypes",
      "allCustomFields",
      "allUsers",
      "allActiveUsers",
      "allContacts",
      "allTags",
      "projectCalendarFilter",
      "initialContacts",
      "initialTags",
      "initialDepartments",
      "userAbilities",
      "GSRecentSearch",
      "userViews",
      "newProjectCreated",
      "deliverableDetail",
      "getDeliverableTemplateSlug",
    ]),
    deliverableTypePlaceholder() {
      if (!this.hasMultipleDeliverableType) {
        return this.deliverableTypes[0].name;
      }

      let currentType = this.filterQuery.deliverableType;
      if (typeof currentType.name != 'undefined') {
        return currentType.name
      } else {
        return 'Deliverables';
      }
    },

    statuses() {
      let statusField = _.find(this.allCustomFields, { field_key: "status" });
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function (item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
    },
    checkPermissions() {
      switch (this.GSDataType) {
        case "tags":
          return (
            this.userAbilities.createTag || this.userAbilities.editMediaCall
          );
        case "contacts":
          return (
            this.userAbilities.createContact || this.userAbilities.editMediaCall
          );
        case "coordinators":
          return this.userAbilities.createUser;
        case "departments":
          return (
            this.userAbilities.createDepartment ||
            this.userAbilities.editMediaCall
          );
      }
    },
    tabType() {
      return typeof this.GSDataType != "undefined" ? this.GSDataType : "";
    },


    hasMultipleDeliverableType() {
      if (!this.deliverableTypes || this.deliverableTypes.length == 0) {
        return true;
      }
      return this.deliverableTypes.length > 1;
    },
  },
  mounted() {
    // hiding the header logo when scrolling in mobile
    if (this.isMobile() && this.$store.getters.isLoggedIn) {

      $('html').removeClass('is__safari');
      var prevScrollpos = window.pageYOffset;
      window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
          document.getElementById("header__controls__project_calendar").style.top = "0";
        } else {
          document.getElementById("header__controls__project_calendar").style.top = "-60px";
        }
        prevScrollpos = currentScrollPos;
      }
    }

    this.initDeliverableTypes();

    this.$root.$on('bv::popover::show', bvEventObj => {
      $('body').addClass('popover-shown');
    });
    this.$root.$on('bv::popover::hide', bvEventObj => {
      $('body').removeClass('popover-shown');
    });
    this.$root.$on('setSaveView', () => {
      this.loadView();
    });
    this.$root.$on('resetFilter', () => {
      this.resetFilter();
    });
    this.onWhoSearch("");
    this.onTagSearch("");
    this.onDepartmentSearch("");

    this.filterQuery = this.projectCalendarFilter;
    if (!this.filterQuery.filterByDate) {
      this.filterQuery.dateRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
    }
    if (!this.filterQuery.filterByDateCreated) {
      this.filterQuery.dateCreatedRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
    }
    if (!this.filterQuery.filterByDateCompleted) {
      this.filterQuery.dateCompletedRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
    }

    // Create deliverable if param is true
    if (typeof this.$route.query.newDeliverable != 'undefined' && typeof this.$route.query.activeTab != 'undefined') {
      if (this.$route.query.newDeliverable == 1 && this.$route.query.activeTab == 0) {
        let that = this;

        // Wait for project id to be defined
        // TODO: a better way to do this?
        let waitForProjectId = setInterval(() => {
          if (that.$store.getters.projectDetail?.id) {
            that.createProjectDeliverable();
            clearInterval(waitForProjectId);
          }
        }, 100);
      }
    }
  },
  methods: {
    ...mapActions([
      'getDeliverableTypes',
      'filterDeliverablesBasedOnSettings',
    ]),
    ...mapMutations(["setDataLoading", "setNewProjectCreated"]),
    createDeliverableType(deliverableType) {
      this.$store.dispatch("createDeliverableType", { deliverableType });
    },
    setPriority() {
      let priority = $('.filter-rating .vue-star-rate ul.list li.active').length;
      this.filterQuery.priorityFilter = priority;
    },
    removeView(viewId) {
      this.$store.dispatch('removeView', viewId);
    },
    loadView() {

    },
    saveView() {
      this.$bvModal.show("viewTitleModal");
    },
    setSort(sortType) {
      this.filterQuery["sort"] = sortType;
    },
    setQuery() {
      this.filterQuery.query = this.searchQuery;
      if (this.$router.currentRoute.name == 'globalSearch') {
        let searchQuery = this.searchQuery;
        let activeTab = this.GSDataType;
        this.$store.commit("setRecentSearch", { searchQuery, activeTab });
      }
    },
    onUpdateDueDate() {
      this.filterQuery.filterByDate = true;
      this.filterQuery.filterNoDueDate = false;
      this.focusFilterBtn();
    },
    onUpdateDateCreated() {
      this.filterQuery.filterByDateCreated = true;
      this.focusFilterBtn();
    },
    onUpdateDateCompleted() {
      this.filterQuery.filterByDateCompleted = true;
      this.focusFilterBtn();
    },

    onWhoSearch(input) {
      if (input != "" || this.initialContacts.length == 0) {
        this.isContactsLoading = true;
        if (typeof window.LIT !== "undefined") {
          clearTimeout(window.LIT);
        }
        window.LIT = setTimeout(() => {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(
                process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input)
              )
              .then((resp) => {
                this.isContactsLoading = false;
                this.contacts = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  resp.data[x]["name"] =
                    resp.data[x]["first_name"] +
                    " " +
                    resp.data[x]["last_name"];
                  this.contacts.push(resp.data[x]);
                }
                this.$store.commit("setInitialData", {
                  contacts: this.contacts,
                });
                resolve(this.contacts);
              })
              .catch((error) => {
                reject(error);
              });
          });
        }, 500);
      } else {
        this.contacts = this.initialContacts;
      }
    },
    onTagSearch(input) {
      if (input != "" || this.initialTags.length == 0) {
        this.isTagsLoading = true;
        if (typeof window.LIT1 !== "undefined") {
          clearTimeout(window.LIT1);
        }
        window.LIT1 = setTimeout(() => {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(process.env.MIX_API_BASE_URL + "tags?q=" + encodeURI(input))
              .then((resp) => {
                this.isTagsLoading = false;
                this.tags = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.tags.push(resp.data[x]);
                }
                this.$store.commit("setInitialData", { tags: this.tags });
                resolve(this.tags);
              })
              .catch((error) => {
                reject(error);
              });
          });
        }, 500);
      } else {
        this.tags = this.initialTags;
      }
    },
    onDepartmentSearchClose(input) {
      //console.log(input);
    },
    onDepartmentSearch(input) {
      if (input != "" || this.initialDepartments.length == 0) {
        this.isDepartmentsLoading = true;
        if (typeof window.LIT2 !== "undefined") {
          clearTimeout(window.LIT2);
        }
        window.LIT2 = setTimeout(() => {
          input = input == false ? "" : input;
          new Promise((resolve, reject) => {
            axios
              .get(
                process.env.MIX_API_BASE_URL +
                "activeDepartments?q=" +
                encodeURI(input)
              )
              .then((resp) => {
                this.isDepartmentsLoading = false;
                this.departments = [];
                let x = 0;
                for (x = 0; x < resp.data.length; x++) {
                  this.departments.push(resp.data[x]);
                }
                this.$store.commit("setInitialData", {
                  departments: this.departments,
                });
                resolve(this.departments);
              })
              .catch((error) => {
                this.isTagsLoading = false;
                reject(error);
              });
          });
        }, 500);
      } else {
        this.departments = this.initialDepartments;
      }
    },
    resetFilter() {
      this.$root.$emit('resetView');
      this.filterQuery.filterNoDueDate = false;
      this.filterQuery.noDepartment = "not_accepted";
      this.filterQuery.noOutlet = "not_accepted";
      this.filterQuery.query = null;
      this.searchQuery = "";
      this.filterQuery.priorityFilter = 0;
      $('.filter-rating .vue-star-rate ul li').each(function () {
        $(this).removeClass('active');
      })
      this.filterQuery.filterByDate = false;
      this.filterQuery.dateRange = {
        startDate: new Date(),
        endDate: new Date(),
      };

      this.filterQuery.filterByDateCreated = false;
      this.filterQuery.dateCreatedRange = {
        startDate: new Date(),
        endDate: new Date(),
      };

      this.filterQuery.filterByDateCompleted = false;
      this.filterQuery.dateCompletedRange = {
        startDate: new Date(),
        endDate: new Date(),
      };
      this.filterQuery.status = [];
      this.filterQuery.outlet = [];
      this.filterQuery.deliverableType = [];
      this.filterQuery.tag = [];
      this.filterQuery.sort = '';
      this.filterQuery.coordinator = [];
      this.filterQuery.department = [];
    },
    outside() {
      this.showUserSelect = false;
    },
    setStatusFilter(status) {
      if (this.filterQuery.status.indexOf(status) != -1) {
        this.removeFilter(status);
      } else {
        this.filterQuery.status.push(status);
      }
    },
    removeFilter(data) {
      if (typeof data != "undefined") {
        if (typeof data == "string") {
          if (
            this.$router.currentRoute.name == "globalSearch" &&
            data == "resetDepartStatus"
          ) {
            this.filterQuery.status = [];
          }
          if (data == 'resetPriorityFilter') {
            this.filterQuery.priorityFilter = 0;
            $('.filter-rating .vue-star-rate ul li').each(function () {
              $(this).removeClass('active');
            });
          }
          if (
            this.$router.currentRoute.name == "globalSearch" &&
            data == "resetDepartTagSort"
          ) {
            this.filterQuery.sort = "";
          }
          if (
            this.$router.currentRoute.name != "globalSearch" &&
            data == "resetDeliverableSort"
          ) {
            this.filterQuery.sort = "";
          }
          if (data == 'deliverableType') {
            this.filterQuery.deliverableType = [];
          }
          if (data == "filterByDate") {
            this.filterQuery.filterByDate = false;
            this.filterQuery.dateRange.startDate = new Date();
            this.filterQuery.dateRange.endDate = new Date();
          }
          if (data == "filterByDateCreated") {
            this.filterQuery.filterByDateCreated = false;
            this.filterQuery.dateCreatedRange.startDate = new Date();
            this.filterQuery.dateCreatedRange.endDate = new Date();
          }
          if (data == "filterByDateCompleted") {
            this.filterQuery.filterByDateCompleted = false;
            this.filterQuery.dateCompletedRange.startDate = new Date();
            this.filterQuery.dateCompletedRange.endDate = new Date();
          }
        } else {
          this.filterQuery.deliverableType = this.filterQuery.deliverableType.filter((s) => {
            return s.name != data.name;
          });

          this.filterQuery.status = this.filterQuery.status.filter((s) => {
            return s.name != data.name;
          });

          this.filterQuery.coordinator = this.filterQuery.coordinator.filter(
            (s) => {
              return s.name != data.name;
            }
          );
          this.filterQuery.outlet = this.filterQuery.outlet.filter((s) => {
            return s.name != data.name;
          });
          this.filterQuery.deliverableType = this.filterQuery.deliverableType.filter((s) => {
            return s.name != data.name;
          });
          this.filterQuery.tag = this.filterQuery.tag.filter((s) => {
            return s.name != data.name;
          });
          this.filterQuery.department = this.filterQuery.department.filter(
            (s) => {
              return s.name != data.name;
            }
          );
        }
      } else {
        // TODO:  Check if a filter can be anything other than a string or object.
      }
    },
    triggerSearch() {
      if (this.$refs.searchQuery.value != "") {
        this.$store.dispatch("fetchProjectCalendarDeliverable");
      }
    },
    focusFilterBtn() {
      if (typeof this.$refs.filterBoxBtn != "undefined") {
        this.$refs.filterBoxBtn.focus();
      } else if (typeof this.$refs.GSCreatedDate != "undefined") {
        this.GSCreatedDatePopover = false;
      }
    },
    createNewDeliverable() {
      let type = this.deliverableType.id;


      if (this.deliverableType.slug) {
      	type = this.deliverableType.slug;
      }

      const projectDetail = this.$store.getters.projectDetail;
      let that = this;
      this.$store.dispatch("createDeliverableForProject", { type, projectId: projectDetail.id }).then(() => {
        that.deliverableType = '';
        that.$bvModal.show("editDeliverableModal");
        that.$nextTick(() => {
          $(".edit-deliverable-modal .deliverable-title").trigger("click");
        });
        that.$store.dispatch("fetchProjectCalendarDeliverable");
      });
    },

    // Hardcode
    createProjectDeliverable() {
      let type = this.deliverableType.id;
      const projectDetail = this.$store.getters.projectDetail;
      let that = this;
      this.$store.dispatch("createDeliverableForProject", { type, projectId: projectDetail.id }).then(() => {
        that.deliverableType = '';
        that.$bvModal.show("editDeliverableModal");
        that.$nextTick(() => {
          $(".edit-deliverable-modal .deliverable-title").trigger("click");
        });
        that.$store.dispatch("fetchProjectCalendarDeliverable");

        that.setDataLoading(true);
        that.$store.dispatch("fetchProjectCalendarDeliverable").then(() => {
          that.setDataLoading(false);
        });
      });
    },
    createNewDeliverable() {
      let type = this.deliverableType.id;
      const projectDetail = this.$store.getters.projectDetail;
      let that = this;

      if (this.deliverableType.slug) {
      	type =  this.deliverableType.slug;
      }


      this.$store.dispatch("createDeliverableForProject", { type, projectId: projectDetail.id }).then(() => {

        // shows edit deliverable modal
        let deliverableId = that.deliverableDetail.id;
        let modalId = "editDeliverableModal";

        let template_slug = this.getDeliverableTemplateSlug(parseInt(that.deliverableDetail.deliverable_template_id));
        if (template_slug == "social-media") {
          modalId = "editSocialModal";
          if (that.deliverableDetail.social_series) {
            if (that.deliverableDetail.social_series.length && !that.deliverableDetail.manually_updated_at) {
              deliverableId = this.getSeriesMasterByDeliverable(that.deliverableDetail);
            }
          }
        }
        if (template_slug == "organic-social-media-plan") {
          modalId = "editOrganicSocialMediaPlanModal";
        }

        let currentTitle = document.title.match(/\(\d+\)\s/g);
        if (!currentTitle) {
          document.title = that.deliverableDetail.title;
        } else {
          document.title = currentTitle[0] + that.deliverableDetail.title;
        }
        that.$bvModal.show(modalId);

        that.setDataLoading(true);
        that.$store.dispatch("fetchProjectCalendarDeliverable").then(() => {
          that.setDataLoading(false);
        });
      });
    },
    createDeliverableDropdownClick(type) {
      this.deliverableType = type;
      this.createNewDeliverable();
    },
    canCreateDeliverableForProject() {
      if (this.userAbilities.accessAllProjects) {
        return this.userAbilities.createMediaCall;
      }

      const userId = localStorage.getItem("userId");
      const projectDetail = this.$store.getters.projectDetail;

      let isManager = false;
      if (projectDetail.engagement_manager instanceof Object || projectDetail.project_lead instanceof Object) {
        isManager = userId == projectDetail.engagement_manager.id || userId == projectDetail.project_lead.id;
      } else {
        isManager = userId == projectDetail.engagement_manager || userId == projectDetail.project_lead;
      }

      return (this.userAbilities.createMediaCall && isManager);
    },
    async initDeliverableTypes() {
      await this.getDeliverableTypes();
      await this.filterDeliverablesBasedOnSettings();
      // Hardcode
      let projectDeliverableType = this.deliverableTypes.find(x => x.typeId == 8);
      if (projectDeliverableType) {
        this.deliverableType = projectDeliverableType;
      } else {
        this.deliverableType = this.deliverableTypes[0];
      }
    },
  },
  watch: {
    filterQuery: {
      handler: function (val, oldVal) {
        this.$root.$emit('showUpdateViewText', val);
        this.filterQuery["myWeek"] = this.myWeek;
        if (
          this.filterQuery.filterByDate &&
          this.filterQuery.dateRange.startDate == null
        ) {
          this.filterQuery.filterByDate = false;
          this.filterQuery.dateRange = {
            startDate: new Date(),
            endDate: new Date(),
          };
          this.filterQuery.filterNoDueDate = true;
        }
        if (this.filterQuery.filterNoDueDate) {
          this.filterQuery.filterByDate = false;
        }
        this.$store.commit(this.namespace + "setProjectCalendarFilter", this.filterQuery);
        if (!this.initialized) {
          this.initialized = true;
          if (this.newProjectCreated) {
            $(".edit-project-modal .project-title").trigger("click");
            this.setNewProjectCreated(false);
          }
          if (typeof this.$route.query.activeTab != 'undefined' && this.$route.query.activeTab == '0') {
            this.$nextTick(() => {
              var cardEl = $('#projectBottomCard')[0];
              window.scrollTo(0, cardEl.offsetTop);
            });
          } else {
            this.$nextTick(() => {
              window.scrollTo(0, 0);
            });
          }
        } else {
          this.$root.$emit('calendarHeaderFilterUpdated');
        }
        if (
          !this.filterQuery.query &&
          !this.filterQuery.filterByDate &&
          !this.filterQuery.filterByDateCreated &&
          !this.filterQuery.filterByDateCompleted &&
          !this.filterQuery.status.length &&
          !this.filterQuery.coordinator.length &&
          !this.filterQuery.tag.length &&
          !this.filterQuery.department.length &&
          !this.filterQuery.outlet.length &&
          ((Array.isArray(this.filterQuery.deliverableType) && !this.filterQuery.deliverableType.length) || (!Array.isArray(this.filterQuery.deliverableType) && !this.filterQuery.deliverableType)) &&
          this.filterQuery.noDepartment != "accepted" &&
          this.filterQuery.noOutlet != "accepted" &&
          !this.filterQuery.filterNoDueDate &&
          !this.filterQuery.sort &&
          this.filterQuery.priorityFilter == 0
        ) {
          $(".deliverable-listing").removeClass("hasFilter");
          $(".global-search-data-wrapper").removeClass("hasFilter");
        } else {
          $(".deliverable-listing").addClass("hasFilter");
          $(".global-search-data-wrapper").addClass("hasFilter");
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.multiselect__option:hover .text-muted {
  color: var(--darken-primary-bg-contrast-text-color) !important;
}
</style>